import Search from '../modules/components/search';

export default function setSearchScripts () {
    if (!window.location.search.includes('?s=')) return;

    new Search();
}
